module.exports = __webpack_public_path__ + "static/media/greenBg.9b770fe9.png";